import styled from "styled-components";

export default styled.div`
  display: none;

  .menu-mobile {
  }

  @media screen and (max-width: 768px) {
    display: block;

    .menu-mobile {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0.25rem;
      background-color: rgba(218, 218, 218, 0);
      backdrop-filter: blur(25px);
      -webkit-backdrop-filter: blur(25px);
    }
  }
`;
